import { Injectable } from '@angular/core';
import { GatewayAPIService } from '../../core/gateway-api.service';
import { OrderDetails } from '../orders/orderDetails';
import { Page } from '../../components/ui/filterable-table/tableViewAbstractComponent';
import { StorageService } from '../../core/storage/storageService';

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  options = { authenticate: true, setRoot: true };

  constructor(
    private api: GatewayAPIService,
    private storage: StorageService,
  ) {}

  public getOrder(orderId: string): Promise<OrderDetails> {
    return this.get({ id: orderId });
  }

  private get(data: any): Promise<OrderDetails> {
    return this.api.apiCallSane(
      '/order',
      'GET',
      this.api.getDefaultHeaders(),
      data,
      null,
      this.options,
    );
  }

  getPaged(query: string, data: any): Promise<Page<OrderDetails>> {
    data.q = query;

    let usr = this.storage.getCurrentUser();

    if (usr) {
      data.userId = usr.id;
    }

    return this.api
      .apiCallSane(
        '/orders',
        'GET',
        this.api.getDefaultHeaders(),
        data,
        null,
        this.options,
      )
      .then(
        (response: Partial<Page<OrderDetails>>) =>
          new Page<OrderDetails>(response),
      );
  }
}
